(function() {
  'use strict';

  function BulkActionCreateOrEditController(
    $q,
    $translate,
    AsyncTasks,
    BulkActionsService,
    Form,
    Utils
  ) {
    var ctrl = this;

    function setDefaultsFromAction(availableActions, selectedValue) {
      var selectedBulkAction = _.find(availableActions, function(action) {
        return action.id === selectedValue;
      });
      ctrl.model = {
        taskAction: selectedBulkAction.id,
        readableAction: selectedBulkAction.name
      };

      ctrl.operation = selectedBulkAction.operation;
      if (selectedBulkAction && selectedBulkAction.defaults) {
        ctrl.model = { ...ctrl.model, ...selectedBulkAction.defaults };
      }
    }

    ctrl.$onInit = function() {
      if (_.isUndefined(ctrl.bulkActionId)) {
        Utils.setPageTitle('New bulk action');
        BulkActionsService.getAvailableBulkActions()
          .then(function(availableBulkActions) {
            var defaultAction = availableBulkActions.length > 0 ? availableBulkActions[0] : null;
            if (defaultAction) {
              setDefaultsFromAction(availableBulkActions, defaultAction.id);
            }

            ctrl.taskActionChooserForm = new Form([
              {
                id: 'taskAction',
                type: 'discrete',
                label: $translate.instant('What action would you like to perform?'),
                required: true,
                defaultValue: availableBulkActions.length > 0 ? availableBulkActions[0].id : null,
                options: _.map(availableBulkActions, function(action) {
                  return {
                    _id: action.id,
                    name: action.name,
                    defaults: action.defaults,
                    operation: action.operation
                  };
                }),
                onChange: function(selectedValue) {
                  setDefaultsFromAction(availableBulkActions, selectedValue);
                }
              }
            ]);
          });
      } else {
        AsyncTasks.find(ctrl.bulkActionId, { cached: false })
          .then(function(bulkActionDoc) {
            if (bulkActionDoc.action !== 'import_file') {
              return $q.reject({ status: 405, message: 'This bulk action cannot be edited' });
            }

            // get the bulk action name and id
            BulkActionsService.getBulkActionByDocTypeAndOperation(
              bulkActionDoc.data.docType,
              bulkActionDoc.data.operation
            )
              .then(function(bulkAction) {
                if (bulkAction) {
                  ctrl.bulkActionName = bulkAction.name;
                  ctrl.operation = bulkAction.operation;
                }
              });

            var importDoc = bulkActionDoc;

            Utils.setPageTitle('Edit bulk action task: ' + importDoc.data.name);
            if (_.indexOf(['new', 'processing'], importDoc.state) > -1) {
              var msg = 'You cannot restart a new import of a running or completed task';
              return $q.reject(
                { status: 405, message: msg }
              );
            }

            var data = importDoc.data;

            // deserialize (a bit ugly :()
            if (data.extra) {
              data.eventTypeId = data.extra.event_type_id;
              data.sectionId = data.extra.section_id;
              data.bookingItemId = data.extra.bookingItemId;
              data.bookingOptionId = data.extra.bookingOptionId;

              if (data.extra.origin) {
                data.originName = data.extra.origin.name;
                data.originId = data.extra.origin.id;
                delete data.extra;
              }
            }
            ctrl.model = data;
          })
          .catch(Utils.showError);
      }
    };
  }

  BulkActionCreateOrEditController.$inject = [
    '$q',
    '$translate',
    'AsyncTasksService',
    'BulkActionsService',
    'FormsService',
    'UtilsService'


  ];

  angular.module('component.bulkActions')
    .controller('BulkActionCreateOrEditController', BulkActionCreateOrEditController);
})();
